import { Box, Button } from "@flexisaf/flexibull2";
import { MyCropper } from "../ImageUploader/cropper";
import Theme from "../../theme";

function SectionImageUploader({
  hasImage,
  imageSrc,
  setHasImage,
  setImage,
  image,
  data,
  updateImage,
}) {
  return (
    <>
      <Box>
        {!hasImage && imageSrc === "" ? (
          <Box pad="20px 0 20px 0" style={{ float: "right" }}>
            <Button onClick={() => setHasImage(true)}>Add Image</Button>
          </Box>
        ) : (
          <>
            {hasImage && (
              <Box marginTop="5px">
                <Box align="center" pad="10px 0">
                  <MyCropper
                    imageName="section_image"
                    onUpload={(file) => setImage(file)}
                    style={{ margin: "auto" }}
                  />
                </Box>
                <Box
                  display="flex"
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    marginTop: "5px",
                  }}
                >
                  <Button
                    onClick={() => {
                      setHasImage(false);
                      setImage(null);
                    }}
                    color={Theme.PrimaryRed}
                    fontColor="#fff"
                  >
                    {image ? "Delete" : "Cancel"}
                  </Button>
                </Box>
              </Box>
            )}
            {data && imageSrc !== "" && !hasImage && (
              <Box align="center" style={{ top: "10px" }} pad="10px 0" relative>
                <Box>
                  <img src={imageSrc} alt="question_image" />
                </Box>
                <Box
                  style={{
                    position: "absolute",
                    right: "5rem",
                    top: "10px",
                  }}
                >
                  <Button onClick={updateImage} color={Theme.PrimaryRed}>
                    <i
                      className="saf-close-circle"
                      style={{ fontSize: "1.2rem" }}
                    />
                  </Button>
                </Box>
              </Box>
            )}
          </>
        )}
      </Box>
    </>
  );
}

export default SectionImageUploader;
